<script>
    import Buttons from './Buttons.svelte';
    import Heading from './Heading.svelte';
    import Text from './Text.svelte';
    import Image from './Image.svelte';
    import Video from './Video.svelte';
    import ImageController from './ImageController.svelte';

    export let data;

    //TODO: Need to move the "defaultOption" out as a Craft field so ImageController can make the decision
    let currentImage = data.storageSolutionsAsset[0].asset.length > 1 ? 2 : 0;

    function swapPhoto(event) {
		currentImage = event.detail.index;
	}

    //console.log("Photo Feature: ", data);
</script>

<div class="lg:flex lg:items-center w-full my-8 lg:my-24" class:flex-row-reverse="{data.storageSolutionsAlignment === 'right' ? true : false}">

    <div class="lg:w-1/2 lg:items-center">
        {#if data.storageSolutionsAsset.length > 0}
            {#if data.storageSolutionsAsset[0].asset[0].kind === "video"}
                <Video 
                    url={data.storageSolutionsAsset[0].asset[0].url}
                    mime={data.storageSolutionsAsset[0].asset[0].mime}
                    data={data}
                    options={
                        {
                        autoplay: true,
                        loop: true,
                        muted: true,
                        playsinline: true,
                        controls: false
                        }
                    }
                />
            {:else}
                <Image imageData={data.storageSolutionsAsset[0].asset[currentImage].storageSolutionsOptimizedImages} />
            {/if}
        {/if}
    </div>

    <div class="lg:w-1/2 py-6 lg:py-2 px-4 lg:px-12 text-center lg:text-left">
        {#each data.children as block}
            <!-- Heading -->
            {#if block.blockType === 'heading'}
                <Heading data={block} />

                <!-- Image controller toggle -->
                {#if data.storageSolutionsAsset[0].asset.length > 1}
                    <p>
                        <span class="inline-block mt-2">
                            <ImageController imageData={data.storageSolutionsAsset[0].asset} selectedOption={currentImage} on:select={swapPhoto} />
                        </span>
                    </p>
                {/if}

            <!-- Text -->
            {:else if block.blockType === 'text'}
                <Text>
                    {@html block.storageSolutionsText}
                </Text>

            <!-- Button -->
            {:else if block.blockType === 'button'}
            <Buttons data={block} />

            <!-- Icons -->
            {:else if block.blockType === 'icons'}
                <div style="border-top: 1px solid #ccc;" class="flex justify-evenly mt-8 pt-8">
                    {#each block.storageSolutionsIcons as icon, i}
                        <div class="flex-1 text-center px-1" data-aos="fade" data-aos-delay="{i*600}">
                            {#if icon.iconAsset[0]}
                                <svg width="30" height="30" class="mx-auto">       
                                    <image xlink:href="{icon.iconAsset[0].url}" width="30" height="30"/>    
                                </svg>
                            {/if}
                            <p class="mt-2 text-sm leading-4">{icon.iconTitle}</p>
                        </div>
                    {/each}
                </div>
            {/if}
        {/each}
    </div>
</div>